// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleDataModelAccessTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { invoke, isNil } from 'lodash/fp';
import connect from 'share/enhancers/Izenda.Connect';

import Input from 'share/components/controls/Izenda.Input';
import SearchTextBox from 'share/components/controls/Izenda.SearchTextBox';
import TextHighLight from 'share/components/controls/Izenda.TextHighLight';
import LazyLoadingTreeView from 'share/components/controls/LazyLoadingTreeView/Izenda.LazyLoadingTreeView';
import { DEFAULT_ITEMS_LAZY_LOADING } from 'logic/data/Izenda.RoleSetupConstants';

@connect()
export default class RoleDataModelAccessTree extends Component {
  resetScrollPosition() {
    // Scroll to top when reload data model access
    this.treeScrollbox.scrollVertical(0);
  }

  handleSearch = (evt: any) => {
    const { dataModel, store } = this.props;
    this.resetScrollPosition();

    dataModel.filterText = evt.target.value;
    store.searchDataSourceItems(dataModel.filterText);
  };

  handleToggleShowQuerySource = (evt: any) => {
    const { store, loader } = this.props;
    this.resetScrollPosition();

    loader.startLoading();
    store.handleToggleShowSelectedQuerySource(evt.target.checked).then(() => loader.endLoading());
  };

  handleChange(node: any, parent: any, evt: any) {
    node.onChange(node.source, parent, evt);
    this.props.store.handleChangeDataSourceItems(node, parent);
  }

  renderNode = (node: any, toggleIcon: any, toggle: any, isCollapsed: boolean, parent: any): any => {
    const { source, disabled, showTotal } = node;
    const onChangeFunc = this.handleChange.bind(this, node, parent);
    const filterText = this.props.dataModel.filterText;

    return (
      <div className="checkbox u_noMarginAll">
        <label>
          <Input
            type="checkbox"
            indeterminate={source.indeterminate}
            checked={disabled ? false : source.checked}
            onChange={onChangeFunc}
            disabled={disabled}
          />

          <TextHighLight text={source.name} highlight={filterText} className="u_textNormal" />

          {showTotal && (
            <span className="selectable u_inline">({`${source.numOfCheckedChilds}/${source.numOfChilds}`})</span>
          )}
        </label>
        {toggleIcon}
      </div>
    );
  };

  getKey = (node: any): string => {
    return node.source.id + '_' + node.source.parentId;
  };

  getTreeScrollbox = (element: any) => {
    this.treeScrollbox = element;
  };

  render() {
    const {
      dataModel: { displayData, isLastPage, filterText, showCheckedQuerySource },
      store,
      localization
    } = this.props;

    return (
      <div className="izenda-CommonTree u_table u_fullSize u_borderAll">
        <div className="u_tableRow">
          <div className="u_tableCell u_paddingAll u_borderBottom">
            <span className="icon-menu" />
            <span className="u_textBold">
              {localization.getText('ROLE_SETUP_CONSTANT_DATA_MODEL_ACCESS_TREE_HEADER')}
            </span>
            <div className="checkbox u_inline u_marginLeft">
              <label>
                <Input type="checkbox" checked={showCheckedQuerySource} onChange={this.handleToggleShowQuerySource} />
                <span>{localization.getText('COMMON_LABEL_SHOW_SELECTED_ITEMS_ONLY')}</span>
              </label>
            </div>
          </div>
        </div>
        <div className="u_tableRow">
          <div className="u_tableCell u_paddingAll u_borderBottom">
            <div className="u-posRelative">
              <SearchTextBox debounceOnChange value={filterText} onChange={this.handleSearch} />
            </div>
          </div>
        </div>
        <div className="u_tableRow">
          <div className="u_tableCell u_fullSize">
            {!isNil(store.roleDetail.key) && (
              <LazyLoadingTreeView
                nodes={displayData}
                getKey={this.getKey}
                isLastPage={isLastPage}
                className="u_paddingRight u_paddingBottom"
                renderNode={this.renderNode}
                getTreeScrollbox={this.getTreeScrollbox}
                getChildNodes={invoke('getChildNodes')}
                defaultItemsNumber={DEFAULT_ITEMS_LAZY_LOADING}
                viewHeight={store.lazyLoadingStore.viewHeight}
                itemHeight={store.lazyLoadingStore.itemHeight}
                getData={store.getConnectionDetailInfo.bind(store)}
                registerLazyLoadingStore={store.registerLazyLoadingStore.bind(store)}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/DataModelAccess/Izenda.RoleDataModelAccessTree.jsx